module.exports = __webpack_public_path__ + "f9495794b5ab6fbe20b9c958bcf1d99a.png";